import { z } from 'zod';
import { ReferralPayloadInput } from './my-referrals';

export const CheckReferralDuplicatesInput = z.object({
  referralId: z.string().uuid().nullable().default(null),
  cycleId: z.string().uuid().nullable().default(null),
  payload: ReferralPayloadInput,
});
export type CheckReferralDuplicatesInput = z.infer<typeof CheckReferralDuplicatesInput>;

export const CheckReferralDuplicatesResult = z.object({ possiblyRelated: z.boolean() });
export type CheckReferralDuplicatesResult = z.infer<typeof CheckReferralDuplicatesResult>;

export const ExistingFamilyConflict = z.object({
  existingReferralId: z.string().uuid().nullable(),
  existingReferenceNumber: z.string().nullable(),
});
export type ExistingFamilyConflict = z.infer<typeof ExistingFamilyConflict>;
